import { render, staticRenderFns } from "./AncestrylineDataTable.vue?vue&type=template&id=b8bae342&scoped=true"
import script from "./AncestrylineDataTable.vue?vue&type=script&lang=js"
export * from "./AncestrylineDataTable.vue?vue&type=script&lang=js"
import style0 from "./AncestrylineDataTable.vue?vue&type=style&index=0&id=b8bae342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bae342",
  null
  
)

export default component.exports